export default __webpack_public_path__ + "static/media/favicon-il.4acdf10d.ico";